import ApprovalPending from "@/Component/WithoutLayout/ApprovalPending";
import type { Metadata } from "next";

export const metadata: Metadata = {
    title: "Pending Approval",
};

const ApprovalPendingPage = () => {
    return (
        <ApprovalPending />
    )
}

export default ApprovalPendingPage
